import { RootState } from '@reducers';

export const selectCancerQuoteComparePage = (state: RootState) => state.cancerQuoteComparePageReducer;
